import React from 'react';
import { KyowaKirinWordmark } from './concept/KyowaKirinWordmark';
export type View = 'main' | 'insights';
type PresentationBarProps = {
  view: View;
  onOpenInsights: () => void;
  onHome: () => void;
};
export function PresentationBar({
  view,
  onOpenInsights,
  onHome
}: PresentationBarProps) {
  return <div className="relative z-30 shrink-0 border-b border-rule bg-white" data-id="element-651" data-mp="36wzht0bblgr2">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-5 md:px-8" data-id="element-652" data-mp="2a805na7m7utl">
        <div className="flex min-w-0 items-center gap-5" data-id="element-653" data-mp="2f6bfhkxwu5bt">
          <button type="button" onClick={onHome} aria-label="Kyowa Kirin — back to the presentation" className="rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy" data-id="element-654" data-mp="2f4qkju7ookdf">
            <KyowaKirinWordmark data-id="element-655" data-mp="1rh0go904el0b" />
          </button>
          <span className="hidden h-7 w-px bg-rule lg:block" aria-hidden="true" data-id="element-656" data-mp="1vi2fioq4kv1r" />
          <p className="hidden truncate font-mono text-[11px] tracking-[0.24em] text-graphite/70 lg:block" data-id="element-657" data-mp="1rabr1h4jipo8">
            KYOWA KIRIN × SNAKKER™ · ILLUSTRATIVE CONCEPT
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2" data-id="element-658" data-mp="1hks5u4tcujq7">
          <button type="button" onClick={onOpenInsights} aria-pressed={view === 'insights'} className={`inline-flex items-center whitespace-nowrap rounded-full border px-4 py-2.5 text-[13px] font-medium transition-[background-color,border-color,color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy sm:px-5 sm:text-sm ${view === 'insights' ? 'border-teal bg-teal text-white' : 'border-ink/20 bg-white text-ink hover:border-ink'}`} data-id="element-659" data-mp="1hj7aicz7uwra">
            Insights &amp; Learnings
          </button>
        </div>
      </div>
    </div>;
}